import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export enum InvoiceStatus {
  PAID = 'paid',
  PARTIALLY_PAID = 'partially paid',
  UPCOMING = 'upcoming',
  PENDING = 'pending',
  FULL_REFUND = 'full refund',
  PARTIAL_REFUND = 'partial refund',
  PENDING_REFUND = 'pending refund',
  REFUND_FAILED = 'refund failed',
  VOID = 'void',
  FAILED = 'failed',
  SCHEDULED = 'scheduled',
  INVOICE_SCHEDULED = 'invoice scheduled',
  PAUSED = 'paused',
  PROCESSING = 'processing',
  CANCELLED = 'cancelled',
}

export interface StudentSubscriptionInvoice {
  invoiceDate: string;
  dueDate?: string | null;
  invoiceId: string;
  productName: string;
  status: InvoiceStatus;
  totalAmount: number;
  outstandingAmount: number;
}

interface GetStudentSubscriptionInvoicesParams {
  studentId: string;
  status?: Array<Partial<InvoiceStatus>>;
}

export const getStudentSubscriptionInvoices = async ({
  studentId,
  ...params
}: GetStudentSubscriptionInvoicesParams) => {
  const response = await baseAPI.post<Array<StudentSubscriptionInvoice>>(
    `/subscription-invoices/student/${studentId}`,
    params,
  );
  return response.data;
};

export const useGetStudentSubscriptionInvoices = (
  params: GetStudentSubscriptionInvoicesParams,
) => {
  return useQuery({
    queryKey: [KEYS.STUDENT_SUBSCRIPTION_INVOICES, params.studentId],
    queryFn: () => getStudentSubscriptionInvoices(params),
    // staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
